import { useMemo } from 'react';

const useMobile = () => {
  const isPad = useMemo(() => navigator.maxTouchPoints > 0, [navigator]);

  return [isPad];
};

export default useMobile;
